<template>
    <div class="year-picker">
        <div ref="years-table" class="year-list" @wheel.prevent="wheel">
            <div v-for="it in yearData"
                 :key="it.id" :class="{
                     active: it.id === value,
                     disabled: it.disabled,
                 }"
                 :title="it.hint"
                 class="year"
                 @click="select(it)">
                {{ it.title }}
            </div>
        </div>
    </div>
</template>

<script>
const SCROLL_YEARS = 6;
const COL_COUNT = 3;
const ROW_COUNT = 6;


export default {
    props: {
        value: {
            type: Number,
        },
        minDate: {
            type: Date,
            required: true,
        },
        maxDate: {
            type: Date,
            required: true,
        },
    },
    computed: {
        minYear() {
            if (this.minDate == null)
                return 0;

            return this.minDate.getFullYear();
        },
        maxYear() {
            if (this.maxDate == null)
                return 0;

            return this.maxDate.getFullYear();
        },
        yearData() {
            return this.years.map(it => {
                const disabled = it < this.minYear || it > this.maxYear;
                return {
                    id: it,
                    title: it,
                    disabled: disabled,
                    hint: disabled ? 'Год недоступен для выбора' : 'Выбрать год',
                };
            });
        },
    },
    data() {
        return {
            years: [],
        };
    },
    created() {
        this.initYears();
    },
    watch: {
        value: 'initYears',
    },
    methods: {
        initYears() {
            const result = [];
            const from = this.value - 7;
            const to = COL_COUNT * ROW_COUNT + from;

            for (let i = from; i < to; i++) {
                result.push(i);
            }

            this.years = result;
        },
        wheel($event) {
            const length = this.years.length;

            if ($event.deltaY > 0) {
                const last = this.years[length - 1];
                this.years.splice(0, SCROLL_YEARS);

                for (let i = 1; i <= SCROLL_YEARS; i++) {
                    this.years.push(i + last);
                }

            } else {
                const first = this.years[0];
                this.years.splice(length - SCROLL_YEARS, SCROLL_YEARS);

                for (let i = 1; i <= SCROLL_YEARS; i++) {
                    this.years.unshift(first - i);
                }
            }
        },
        select(it) {
            if (it.disabled)
                return;

            this.$emit('input', it.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.year-picker {
    position: relative;

    &::before,
    &::after {
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        height: 32px;
        background: linear-gradient(0deg, #FFFFFF 24.42%, rgba(255, 255, 255, 0.00520833) 99.99%, rgba(255, 255, 255, 0) 100%);
    }

    &::before {
        transform: rotate(-180deg);
    }

    .year-list {
        grid-template-columns: repeat(3, 1fr);
        height: 214px;
        row-gap: 4px;
        column-gap: 8px;
        display: grid;
        overflow: hidden;
    }

    .year {
        padding: 6px;
        cursor: pointer;
        text-align: center;
        border-radius: 4px;

        &.active,
        &:not(.disabled):hover {
            background: #8887F0;
            color: #FFFFFF;
        }

        &.disabled {
            color: rgba(16, 24, 40, 0.25);
            cursor: not-allowed;
        }
    }
}
</style>
